module.exports = __webpack_public_path__ + "img/trash-can-outline-houver.31bc235d.svg";